// utils/formatTime.ts
export const formatTime = (time?: string) => time?.slice(0, 5);
